import { GetUserEndpointTokenStatusResponse } from 'multirpc-sdk';
import { useMemo } from 'react';

import { ProjectStatusLabelType } from 'domains/projects/const';

export interface IUseProjectStatusLabelProps {
  status: GetUserEndpointTokenStatusResponse;
  isDraft?: boolean;
}

export const useProjectStatusLabel = ({
  isDraft,
  status,
}: IUseProjectStatusLabelProps) => {
  const projectStatusType = useMemo(() => {
    const { frozen, suspended } = status;

    if (suspended) {
      return ProjectStatusLabelType.Suspended;
    }

    if (isDraft) {
      return ProjectStatusLabelType.Draft;
    }

    if (frozen) {
      return ProjectStatusLabelType.Frozen;
    }

    return ProjectStatusLabelType.Active;
  }, [isDraft, status]);

  return { projectStatusType };
};
